export default __webpack_public_path__ + "static/media/cnd.9362b4fa.png";